import { render, staticRenderFns } from "./OperatorsCreateDoc.vue?vue&type=template&id=1a889ab1"
import script from "./OperatorsCreateDoc.vue?vue&type=script&lang=js"
export * from "./OperatorsCreateDoc.vue?vue&type=script&lang=js"
import style0 from "./OperatorsCreateDoc.vue?vue&type=style&index=0&id=1a889ab1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports